import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TargetTitleLabel = styled.div<{ $isActive?: boolean }>`
  ${({ $isActive }) =>
    $isActive ? typographyV2.titleSm : typographyV2.bodyXs};
  color: ${({ $isActive }) =>
    $isActive ? 'var(--text-default)' : 'var(--text-soft)'};
`;

export const TargetValueLabel = styled.div<{
  $isNegative: boolean;
  $isActive?: boolean;
}>`
  ${({ $isActive }) =>
    $isActive ? typographyV2.titleSm : typographyV2.bodyXs};
  color: ${({ $isNegative }) =>
    $isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  font-family: var(--font-roboto-mono);
`;

export const AverageTargetChangeLabel = styled.div<{ $isNegative: boolean }>`
  ${typographyV2.bodyXs};
  color: ${({ $isNegative }) =>
    $isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  background-color: ${({ $isNegative }) =>
    $isNegative ? 'var(--viz-bearish-soft)' : 'var(--viz-bullish-soft)'};
  ${borderRadius.r1};
  padding: 2px 6px;
`;

export const TargetWrapper = styled.div<{ $isActive?: boolean }>`
  padding: 12px 8px;
  background-color: ${({ $isActive }) =>
    $isActive ? 'var(--surface-default)' : 'transparent'};
  ${borderRadius.r2}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const AverageTargetWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
